import React, { useEffect, useRef, useState } from 'react'
import { ChevronDown, CloudDownload, PersonPlus, PlusLg } from 'react-bootstrap-icons'

export default function AddInfluencerMenu({ onPull, onCreateManually }) {
  const [open, setOpen] = useState(false)
  const containerRef = useRef(null)

  useEffect(() => {
    if (!open) return
    const close = event => {
      if (!containerRef.current?.contains(event.target)) setOpen(false)
    }
    const closeOnEscape = event => event.key === 'Escape' && setOpen(false)
    document.addEventListener('mousedown', close)
    document.addEventListener('keydown', closeOnEscape)
    return () => {
      document.removeEventListener('mousedown', close)
      document.removeEventListener('keydown', closeOnEscape)
    }
  }, [open])

  const choose = action => () => {
    setOpen(false)
    action()
  }

  const items = [
    { label: 'Pull from Modash', hint: 'Import an account with full statistics', icon: CloudDownload, action: onPull },
    { label: 'Create manually', hint: 'Enter a creator and their channels by hand', icon: PersonPlus, action: onCreateManually }
  ]

  return (
    <div ref={containerRef} className="relative">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="flex h-10 items-center gap-2 rounded-lg bg-rb-green px-4 text-sm font-semibold text-white dark:text-rb-dark-mode hover:bg-opacity-90"
      >
        <PlusLg />
        Add influencer
        <ChevronDown className={`text-xs transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="absolute right-0 z-30 mt-2 w-72 overflow-hidden rounded-xl border-1 border-rb-dash-border dark:border-rb-dark-mode-lighter bg-white dark:bg-rb-dark-mode shadow-lg">
          {items.map(({ label, hint, icon: Icon, action }) => (
            <button
              key={label}
              type="button"
              onClick={choose(action)}
              className="flex w-full items-start gap-3 px-4 py-3 text-left hover:bg-rb-grey dark:hover:bg-rb-dark-mode-lighter"
            >
              <Icon className="mt-0.5 shrink-0 text-rb-green" />
              <span>
                <span className="block text-sm font-semibold text-rb-black dark:text-white">{label}</span>
                <span className="block text-xs text-rb-mat-grey dark:text-gray-400">{hint}</span>
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
